module.exports = __webpack_public_path__ + "static/media/Best_card.d7d81c50.svg";